import { Amplify } from 'aws-amplify';

export interface AmplifyConfig {
  region: string;
  userPoolId: string;
  userPoolWebClientId: string;
  oauth: {
    domain: string;
    scope: string[];
    redirectSignIn: string;
    redirectSignOut: string;
    responseType: string;
  };
  apiEndpoint: string;
}

export const configureAmplify = (config: AmplifyConfig) => {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: config.userPoolId,
        userPoolClientId: config.userPoolWebClientId,
        signUpVerificationMethod: 'code',
        loginWith: {
          oauth: {
            domain: config.oauth.domain,
            scopes: config.oauth.scope,
            redirectSignIn: [config.oauth.redirectSignIn],
            redirectSignOut: [config.oauth.redirectSignOut],
            responseType: config.oauth.responseType as 'code' | 'token',
            providers: ['Google']
          }
        }
      }
    }
  });
};